
import displayphoto from "./displayphoto.jpg";
const testimonialData = [
    {
      rating: 5,
      photo: displayphoto,
      content: " The team's creativity and attention to detail turned my vision into a stunning website.",
      author: "John Doe",
      jobTitle: "Software Engineer",
    },
    {
      rating: 4,
      photo: displayphoto,
      content: " I needed a website for my small business, and WebVista delivered beyond my expectations. ",
      author: "Jane Smith",
      jobTitle: "Product Manager",
    },
    {
        rating: 5,
        photo: displayphoto,
        content: "The one-on-one consultation was invaluable. They took the time to understand our goals and provided tailored solutions. ",
        author: "Miss Veev",
        jobTitle: "Product Manager",
      },
      {
        rating: 3,
        photo: displayphoto,
        content: "The branding package from WebVista transformed my business. The logo captured the essence of LuxeLoom.",
        author: "Tester",
        jobTitle: "QA Analysr",
      },
    // Add more testimonial objects as needed
  ];
  
  export default testimonialData;